import React from 'react';
import styles from './styles.module.scss';

import LinkWrap from '../Wraps/LinkWrap';
import Config, { spanish } from '../../config/config';

const Banner = ({ to, isExternal, imgMobile, imgDesktop }) => (
  <div className={styles.banner}>
    <LinkWrap to={to} isExternal={isExternal}>
      <picture>
        <source
          srcSet={Config.cdn.cdn_path + imgDesktop?.url}
          media="(min-width: 760px)"
        />
        <img src={Config.cdn.cdn_path + imgMobile?.url} alt="Forever Living" />
      </picture>
    </LinkWrap>
  </div>
);

const Map = ({ content }) => (
  <div className={styles.map}>
    <div className={styles.mapHead}>
      <h4>{spanish ? content?.TitleMapSpanish : content?.TitleMapEnglish}</h4>
      <p>
        {spanish
          ? content?.DescriptionMapSpanish
          : content?.DescriptionMapEnglish}
      </p>
      <a href={content?.MapLinkURL} target="_blank" rel="noreferrer noopener">
        {spanish ? content?.MapLinkSpanish : content?.MapLinkEnglish}
      </a>
    </div>
  </div>
);

const Bottom = ({ content }) => (
  <div className={styles.bottom}>
    <h4>
      {spanish ? content?.BottomTitleSpanish : content?.BottomTitleEnglish}
    </h4>
    <div className={styles.bottomLinks}>
      <LinkWrap to={content?.Bottom1Link} isExternal={content?.Bottom1External}>
        <picture>
          <img
            src={Config.cdn.cdn_path + content?.Bottom1Image?.url}
            alt="Forever Living"
          />
        </picture>
      </LinkWrap>
      <LinkWrap to={content?.Bottom2Link} isExternal={content?.Bottom2External}>
        <picture>
          <img
            src={Config.cdn.cdn_path + content?.Bottom2Image?.url}
            alt="Forever Living"
          />
        </picture>
      </LinkWrap>
      <LinkWrap to={content?.Bottom3Link} isExternal={content?.Bottom3External}>
        <picture>
          <img
            src={Config.cdn.cdn_path + content?.Bottom3Image?.url}
            alt="Forever Living"
          />
        </picture>
      </LinkWrap>
    </div>
  </div>
);

const About = ({ content }) => {
  const output = content !== null && (
    <div className={styles.container}>
      <Banner
        to={content?.Banner1Link}
        isExternal={content?.Banner1External}
        imgMobile={content?.Banner1Mobile}
        imgDesktop={content?.Banner1Desktop}
      />
      <Banner
        to={content?.Banner2Link}
        isExternal={content?.Banner2External}
        imgMobile={content?.Banner2Mobile}
        imgDesktop={content?.Banner2Desktop}
      />
      <Banner
        to={content?.Banner3Link}
        isExternal={content?.Banner3External}
        imgMobile={content?.Banner3Mobile}
        imgDesktop={content?.Banner3Desktop}
      />
      <Banner
        to={content?.Banner4Link}
        isExternal={content?.Banner4External}
        imgMobile={content?.Banner4Mobile}
        imgDesktop={content?.Banner4Desktop}
      />
      <Map content={content} />
      <Bottom content={content} />
    </div>
  );
  return output;
};

export default About;
